import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { IzvodStavka } from './izvod-stavka';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-izvod-stavka-modal-update',
  templateUrl: './izvod-stavka-modal-update.component.html'
})
export class IzvodStavkaModalUpdateComponent extends BaseModalUpdateComponent<IzvodStavka> {

  constructor(
    protected modalContainerService: ModalContainerService<IzvodStavka>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
){
    super(modalContainerService, activeModal,modalService);
}

}
